import React, { ChangeEvent, useCallback, useState } from 'react'
import "./ModalArchivedScheduleNotification.css"
import moment from 'moment'

import ConfirmButton from '../../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { useTranslation } from 'react-i18next'
import { DayOfWeek} from '../../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'

type ModalResumeScheduleNotificationProps = {
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ModalResumeScheduleNotification = ({
    onSubmit,
    onCloseModal,
}: ModalResumeScheduleNotificationProps) => {

    const { t } = useTranslation()


    return (
        <div className="modal-schedule-notif-archived flex flex-d-column">
           
           <p className="fs-18 fw-500">{t("Notifications:schedule:index:label_32")}</p>

           <p className="fs-13 mb-30 mt-14 color-oslo">
                {t("Notifications:schedule:index:label_33")}
                <span className="color-archived-word">{` ${t("Notifications:schedule:index:label_35")} `}</span>
                {t("Notifications:schedule:index:label_34")}
            </p>
            
            <form onSubmit={onSubmit} className="flex flex-jc-end">

                <button
                    onClick={onCloseModal}
                    className="cancel-btn-archived-notif mr-10 color-oslo fs-12"
                >
                    {t("General:label_015")}
                </button>
                <ConfirmButton text={t("General:label_016")} width="18rem" />

            </form>
            
        </div>
    )
}

export default React.memo( ModalResumeScheduleNotification )